import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {BonusAndCashBalance} from "./bonus-and-cash-balance/bonus-and-cash-balance.component";
import {UserBalanceButtons} from "./balance-box-buttons/user-balance-buttons.component";
import {UserMenuBalanceTitleBox} from "./boxes/user-menu-balance-title.box";
import {UserBalanceSectionBox} from "./boxes/user-balance-section.box";
import {UserBalanceSectionIconBox} from "./boxes/user-balance-section-icon.box";
import { BalanceValue } from './balance-value.component';
import { BalanceValuePrimaryBox } from './balance-value-boxes/balance-value-primary.box';
import {CyClass} from '../../../common/cy-classes';

export const UserBalance = observer(class UserBalance extends OrbitComponent {
  render() {
    const isMobile = this.services.device.isMobile;
    const translator = this.services.translation;

    return (
      <UserBalanceSectionBox className="cy-balance-box">
        {!isMobile && <UserBalanceSectionIconBox />}
        <UserMenuBalanceTitleBox>{translator.translate('BALANCE')}</UserMenuBalanceTitleBox>

        <BalanceValue className={CyClass('cy-balance-box-amount')} WrapperComponent={BalanceValuePrimaryBox} />

        <BonusAndCashBalance />
        {this._renderButtons()}
      </UserBalanceSectionBox>
    );
  }

  private _renderButtons() {
    return (
      <UserBalanceButtons onDeposit={() => this.services.userMenu.launchDeposit()}
                          onWithdraw={() => this.services.userMenu.launchWithdraw()} />
    );
  }
});
